import { Fragment, FunctionComponent, h } from 'preact';
import Avatar from '../avatar/avatar';
import { useTranslation } from '../../hooks/use-translation';

interface Props {
	driverName: string;
	driverImage: string;
	address: string;
	driverArrivedCaptionString?: string;
	driverArrivedString?: string;
}

const DriverArrived: FunctionComponent<Props> = ({
	driverName,
	driverImage,
	address,
	driverArrivedCaptionString,
	driverArrivedString
}) => {
	const { t } = useTranslation();

	const driverArrivedMessage = driverArrivedCaptionString
		? driverArrivedCaptionString
		: t('TRACKING.DRIVER_ARRIVED_MESSAGE');

	const driverLocationMessage = driverArrivedString
		? driverArrivedString
		: `${driverName}, ${t('TRACKING.DRIVER_ARRIVED_AT_MESSAGE')}`;

	return (
		<Fragment>
			<div className="driver-arrived-bg" data-testid="driver-arrived-bg" />
			<div className="driver-arrived" data-testid="driver-arrived">
				<div>{driverArrivedMessage}</div>
				<Avatar profileUrl={driverImage} className="driver-arrived-avatar" />
				<div className="driver-arrived-info">{driverLocationMessage}</div>
				<div className="driver-arrived-address">{address}</div>
			</div>
		</Fragment>
	);
};

export default DriverArrived;
